import React, { useCallback, useContext, useRef } from 'react'
import OfferCalendarDatePickerSelectBox from './OfferCalendarDatePickerSelectBox'
import OfferCalendarDatePicker from './OfferCalendarDatePicker'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions, OfferPageFilterTypes } from 'contexts/OfferPage/offerPageStateReducer'
import Dropdown from 'components/Luxkit/Dropdown/v2/Dropdown'
import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import { calendarAction } from 'analytics/eventDefinitions'
import { fireInteractionEvent } from 'api/googleTagManager'
import { CALENDAR_GA_EVENT_ACTION, CALENDAR_GA_EVENT_LABEL } from 'constants/analytics'
import OfferPageStateTrackingContext from 'contexts/OfferPage/offerPageStateTrackingContext'
import { rem } from 'polished'
import styled from 'styled-components'
import { Placement } from '@floating-ui/react-dom'
import { useIsMobileScreen } from 'lib/deviceUtils'

const Container = styled(DropdownContainer)`
  scroll-padding-top: ${rem(40)};
  width: 100vw;
  max-height: min(calc((var(--vh, 1vh) * 100) - ${rem(200)}), ${rem(820)});
`

interface Props {
  open: boolean;
  useRooms?: boolean;
  defaultDayPicker?: boolean;
  defaultMonth?: string;
  onClickLabel: string;
  offer: App.Offer;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /**
   * Provide a list of 'sub filters' to show as part of this component
   */
  subFilters?: Array<OfferPageFilterTypes>;
  dropdownPosition?: Placement;
}

function OfferCalendarDatePickerSelect(props: Props) {
  const {
    open,
    useRooms,
    defaultDayPicker,
    defaultMonth,
    onClickLabel,
    offer,
    onClick,
    subFilters,
    dropdownPosition,
  } = props
  const { trackEvent } = useContext(OfferPageStateTrackingContext)
  const isMobile = useIsMobileScreen()

  const dispatch = useOfferPageDispatch()
  const triggerRef = useRef<any>(null)

  const onClose = useCallback(() => {
    fireInteractionEvent(calendarAction(offer.analyticsType, CALENDAR_GA_EVENT_ACTION.CloseFilter, CALENDAR_GA_EVENT_LABEL.CloseOutside))
    dispatch({ type: OfferPageActions.closeFilter })
    trackEvent('CALENDAR_CLOSED')
  }, [dispatch, offer.analyticsType, trackEvent])
  const scrollRef = useRef<HTMLDivElement>(null)

  return (<div>
    <OfferCalendarDatePickerSelectBox
      onClickLabel={onClickLabel}
      ref={triggerRef}
      onClick={onClick}
    />
    <Dropdown
      open={open && !isMobile}
      onClose={onClose}
      triggerRef={triggerRef}
      disableFlip
      data-testid="offer-checkin-select"
      position={dropdownPosition}
    >
      <Container
        fit="container"
        ref={scrollRef}
      >
        <OfferCalendarDatePicker
          calendarOpen={open}
          defaultDayPicker={defaultDayPicker}
          defaultMonth={defaultMonth}
          useRooms={useRooms}
          subFilters={subFilters}
          scrollRef={scrollRef}
        />
      </Container>
    </Dropdown>
  </div>
  )
}

export default withOfferPageState(state => ({
  open: state.activeFilter === 'checkin',
  offer: state.offer,
}))(OfferCalendarDatePickerSelect)
